import React, { Component, } from "react"

export default class PageNotFound extends Component {

  render() {
    return (
      <p>Erreur 404</p>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/PageNotFound/index.js